import React from 'react'
import { FirebaseContext } from './Ctx'

class UserProvider extends React.Component {
	state = {
		user: null
	}

	componentDidMount() {
		this.props.firebase.auth().onAuthStateChanged(user => {
			this.setState({ user })
			// if (user) {
			// 	// User is signed in.
			// 	var displayName = user.displayName
			// 	var email = user.email
			// 	var emailVerified = user.emailVerified
			// 	var photoURL = user.photoURL
			// 	var isAnonymous = user.isAnonymous
			// 	var uid = user.uid
			// 	var providerData = user.providerData
			// 	// ...
			// } else {
			// 	// User is signed out.
			// 	// ...
			// }
		})
	}

	render() {
		return this.props.children(this.state.user)
	}
}

const func = props => (
	<FirebaseContext.Consumer>
		{firebase => <UserProvider firebase={firebase} {...props} />}
	</FirebaseContext.Consumer>
)

export default func



// WEBPACK FOOTER //
// ./src/UserProvider.js